import React, { useEffect, useRef, useState } from "react";
import "../../index.css";

function Modal() {
  const [isOpen, setIsOpen] = useState(true);
  const notice = useRef(null);

  useEffect(() => {
    if (isOpen) {
      const handleClickOutSide = (e) => {
        if (notice.current && !notice.current.contains(e.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutSide);
      return () => document.removeEventListener("mousedown", handleClickOutSide);
    }
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div>
          {/* พื้นหลังมืดโปร่ง */}
          <div
            className="fixed inset-0 flex justify-center items-center z-30"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.76)" }}
          >
            {/* กล่อง Modal */}
            <div
              ref={notice}
              className="rounded-xl overflow-hidden 2xl:max-w-[60%] max-w-[100%] p-2 sm:p-3 text-center relative"
                  // className="bg-white rounded-xl shadow-lg overflow-hidden 2xl:max-w-[60%] max-w-[100%] p-2 sm:p-3 text-center relative"
              style={{ backgroundColor: "rgba(255, 255, 255, 0)" }}
            >
              {/* ปุ่มปิดมุมขวา */}
              {/* <div
                onClick={() => setIsOpen(false)}
                className="absolute top-0 right-0 cursor-pointer text-2xl sm:p-3 p-2 z-40"
              >
                &#10060;
              </div> */}

              {/* รูปภาพหลัก */}
              <img
                src="/images/bg/เสด็จสู่ฟากฟ้าสุราลัย banner web-02.jpg"
                alt="Welcome banner"
                className="w-full h-auto"
              />

              {/* ปุ่มเข้าสู่เว็บไซต์ */}
              <div className="col-12 pt-4">
                <button
                  type="button"
                  onClick={() => setIsOpen(false)}
                  className="vs-btn px-6 py-3 text-white rounded-lg transition-all"
                  style={{ backgroundColor: "black" }}
                >
                  เข้าสู่เว็บไซต์ <i className="far fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Modal;
